import i18n from 'i18next';
import * as yup from 'yup';

export function applyYupLocale() {
    yup.setLocale({
        mixed: {
            required: () => i18n.t('validation:required'),
            oneOf: ({ values }) => i18n.t('validation:oneOf', { values: values.join(', ') }),
            notType: ({ type, value }) => (
                value === null || value === undefined || Number.isNaN(value)
                    ? i18n.t('validation:required')
                    : i18n.t('validation:type', { type })
            )
        },
        string: {
            email: () => i18n.t('validation:email'),
            min: ({ min }) => i18n.t('validation:min', { count: min }),
            max: ({ max }) => i18n.t('validation:max', { count: max }),
            matches: () => i18n.t('validation:pattern')
        },
        number: {
            min: ({ min }) => i18n.t('validation:minNumber', { count: min }),
            max: ({ max }) => i18n.t('validation:maxNumber', { count: max }),
            integer: () => i18n.t('validation:integer')
        }
    });
}
